(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('aceptacionServicioService', aceptacionServicioService);

    aceptacionServicioService.$inject = [
        '$q',
        '$rootScope',
        '$templateCache',
        'ModalService',
        'notificationService',
        'clientService',
        '$state',
        'genericDataService',
        'ordersService'
    ];

    function aceptacionServicioService (
        $q,
        $rootScope,
        $templateCache,
        ModalService,
        notificationService,
        clientService,
        $state,
        genericDataService,
        ordersService
    ) {

        /*jshint maxcomplexity:false */
        var MSG_ERROR_DEFAULT = 'Ha ocurrido un error inesperado.';

        var acceptServiceTemplate = $templateCache.get('app/views/modals/aceptacion/acceptServiceTemplate.html');
        var rejectServiceTemplate = $templateCache.get('app/views/modals/aceptacion/rejectServiceTemplate.html');
        var showErrorServiceTemplate = $templateCache.get('app/views/modals/aceptacion/mostrarErrorTemplate.html');
        var manageServiceTemplate = $templateCache.get('app/views/modals/aceptacion/manageServiceTemplate.html');

        var orderAcceptationErrors = {};

        var service = {
            newOrderNotification: newOrderNotification,
            acceptServiceModal: acceptServiceModal,
            rejectServiceModal: rejectServiceModal,
            orderAcceptationErrors: orderAcceptationErrors,
            discardService: discardService,
            showErrorModal: showErrorModal,
            manageService: manageService
        };

        return service;

        //Notificacion Nuevo Servicio
        function newOrderNotification(order) {

            var s = $rootScope.$new();
            s.order = order;
            s.acceptServiceModal = acceptServiceModal;
            s.rejectServiceModal = rejectServiceModal;
            s.onClick = function () {
                $state.transitionTo('flota.OrdenesActivas');
            };

            s.icon = order.insurerId !== null ? clientService.getBrandLogo(order.insurerId) : 'content/img/logo-invesfleet.png';

            var notification = {
                title: 'Existen órdenes nuevas',
                message: 'Click para visualizar',
                icon: s.icon,
                templateUrl: 'app/views/tablesTemplates/notificationTemplates/newOrderNotification.html',
                scope: s,
                onclick: function (e) {
                    window.focus();
                    $state.transitionTo('flota.OrdenesActivas');
                }
            };

            notificationService.sendNotification(notification);

        }

        //Modal de rechazo servicio
        function rejectServiceModal(order) {
            ModalService.showModal({
                template: rejectServiceTemplate,
                controller: function (close) {
                    var modal = this;

                    modal.motivos = {
                        list: null,
                        selected: {}
                    };

                    (function () {
                        modal.motivos.loading = true;
                        genericDataService.getMotivosRechazo(order.idInsurer).then(function (data) {
                            modal.motivos.list = data;
                            modal.motivos.loading = false;
                        });
                    })();

                    modal.accept = function () {
                        ordersService.legacyChangeAssignmentState(order.orderId, 2,
                            null, modal.motivos.selected.id, null).then(function (data) {
                            $rootScope.$broadcast('ReloadOrdenesActivas');
                            notificationService.sendAppNotification({
                                message: 'Servicio rechazado',
                                positionY: 'top',
                                positionX: 'right',
                                delay: 3000,
                                type: 'success'
                            });
                            service.discardService(order);
                        }, function (data) {
                            sendErrorNot(order, 'REJECT', MSG_ERROR_DEFAULT);
                        });
                        $rootScope.blurry = false;
                        close();
                    };

                    modal.cancel = function () {
                        $rootScope.blurry = false;
                        close();
                    };
                },
                controllerAs: 'modal'
            });
        }

        //Modal de aceptación de servicio
        function acceptServiceModal(order) {
            /* jshint maxcomplexity: false */
            var acceptForm = 'app/views/modals/aceptacion/baseAcceptForm.html';

            switch (order.insurerId) {
                case 0: //ASITUR
                    break; //Use baseAcceptForm
                case 1: //RACC
                    return; //No aplica
                case 2: //MAPFRE
                    return; //No aplica
                case 3: //EUROP
                    ordersService.legacyChangeAssignmentState(order.orderId, 1, null, null, null);
                    return;
                case 4: //MUTUA
                    break; //Use baseAcceptForm
                case 5: //RACE
                    break; //Use baseAcceptForm
                case 6: //ALLIANZ
                    break; //Use baseAcceptForm
                case 7: //PELAYO
                    acceptForm = 'app/views/modals/aceptacion/pelayoForm.html';
                    break;
                case 8: //LINEA DIRECTA
                    return; //No aplica
                case 9: //EUROTRANS
                    break;
                case 10: //AXA
                    //acceptForm = 'app/views/modals/aceptacion/pelayoForm.html';
                    break;
                case 11: //IMA IBERICA
                    return; //No aplica
                default:
                    break;

            }

            ModalService.showModal({
                template: acceptServiceTemplate,
                controller: function (close) {
                    var modal = this;
                    modal.extraData = {};
                    modal.acceptForm = acceptForm;
                    modal.tiempoDemora = 0;

                    modal.accept = function () {
                        ordersService.legacyChangeAssignmentState(order.orderId, 1,
                            modal.tiempoDemora, null, modal.extraData).then(function () {
                            $rootScope.$broadcast('ReloadOrdenesActivas');
                            notificationService.sendAppNotification({
                                message: 'Servicio aceptado',
                                positionY: 'top',
                                positionX: 'right',
                                delay: 3000,
                                type: 'success'
                            });
                        }, function () {
                            sendErrorNot(order, 'ACCEPT', MSG_ERROR_DEFAULT);
                        });
                        $rootScope.blurry = false;
                        close();
                    };

                    modal.cancel = function () {
                        $rootScope.blurry = false;
                        close();
                    };

                },
                controllerAs: 'modal'
            });
        }

        //Notificacion de error y reintento
        function sendErrorNot(order, type, msg) {
            var s = $rootScope.$new();
            s.order = order;
            s.icon = order.insurerId !== null ?
                clientService.getBrandLogo(order.insurerId) : 'content/img/logo-invesfleet.png';
            s.msg = msg;
            s.onClick = function () {
                $state.transitionTo('flota.OrdenesActivas');
            };
            var notification = {
                positionY: 'bottom',
                positionX: 'right',
                delay: null,
                type: 'error',
                templateUrl: 'app/views/tablesTemplates/notificationTemplates/acceptErrorNotification.html',
                scope: s
            };

            if (type === 'ACCEPT') {
                notification.message = 'Error aceptando el servicio';
            } else {
                notification.message = 'Error rechazando el servicio';
            }
            notificationService.sendAppNotification(notification);
        }

        function discardService(order) {
            ordersService.removeOrders([order.orderId]).then(function () {
                $rootScope.$broadcast('ReloadOrdenesActivas');
                //console.log('SERVICIO DESCARTADO');
            }, function () {
                //console.log('ERROR DESCARTANDO SERVICIO');
            });
        }

		function manageService(order, accept = true) {
			console.log(order);
            var state = order.assignmentState;
            var title, msg;

            switch (state) {
                case 102:
                    title = 'Servicio rechazado tiempo agotado';
                    msg = 'Confirme con el cliente la aceptación del servicio o descártelo';
                    break;
                case 103:
                    title = 'Servicio rechazado colaborador desconectado';
                    msg = 'Confirme con el cliente la aceptación del servicio o descártelo';
                    break;
				case 7:
					if (accept) {
						title = 'Aceptación sin confirmación';
						msg = 'Aceptar el servicio?';
					}
					else {
						title = 'Rechazo del servicio';
						msg = 'Rechazar el servicio?';
					}
                    break;
                case 8:
                case 104:
                    title = 'Servicio modificado';
                    msg = 'Realice las acciones necesarias en la orden en curso';
                    break;
                case 9:
                case 105:
                    title = 'Servicio dado de baja';
                    msg = 'Realice las acciones necesarias en la orden en curso';
                    break;
                case 10:
                    title = 'Servicio pendiente de presupuesto';
                    msg = 'Ponga el estado adecuado del servicio según el estado del presupuesto';
                    break;
                case 11:
                    title = 'Presupuesto pendiente de aceptación';
                    msg = 'Ponga el estado adecuado del servicio según el estado del presupuesto';
                    break;
                case 106:
                    title = 'Presupuesto rechazado';
                    msg = 'Ponga el estado adecuado del servicio según el estado del presupuesto';
                    break;
                case 107:
                    title = 'Presupuesto aceptado';
                    msg = 'Ponga el estado adecuado del servicio según el estado del presupuesto';
					break;

				case 3:
				case 0:
					title = 'Aceptar timeout';
					msg = 'Desea confirmar que su órden ha sido rechazada por estar fuera de plazo?';
					break;
                default:
                    title = 'Estado ' + state;
                    msg = '-';
                    break;
            }


            ModalService.showModal({
                template: manageServiceTemplate,
                controller: function (close) {

                    var modal = this;

                    modal.state = 7;
                    modal.stateTitle = title;
                    modal.stateMsg = msg;
					switch (state) {
						case 7:
							if (accept) {
								modal.accept = function () {
									ordersService.changeAssignmentState(order.orderId, 100).then(function () {
										notificationService.sendAppNotification({
											message: 'Servicio aceptado',
											positionY: 'top',
											positionX: 'right',
											delay: 3000,
											type: 'success'
										});
										$rootScope.$broadcast('ReloadOrdenesActivas');
										$rootScope.blurry = false;
										close();
									}, function () {
										//console.log('ACEPTACION DIRECTA: ERROR pasando servicio a ACEPTADO (100)');
										$rootScope.blurry = false;
										close();
									});
								};
							}
							else {
								modal.accept = function () {
									ordersService.changeAssignmentState(order.orderId, 2).then(function () {
										notificationService.sendAppNotification({
											message: 'Servicio rechazado',
											positionY: 'top',
											positionX: 'right',
											delay: 3000,
											type: 'success'
										});
										$rootScope.$broadcast('ReloadOrdenesActivas');
										$rootScope.blurry = false;
										close();
									}, function () {
										//console.log('ACEPTACION DIRECTA: ERROR pasando servicio a ACEPTADO (100)');
										$rootScope.blurry = false;
										close();
									});
								};
							}
							break;
						case 3:
						case 0:
							modal.accept = function () {
								ordersService.changeAssignmentState(order.orderId, 101).then(function () {
									notificationService.sendAppNotification({
										message: 'Timeout confirmado',
										positionY: 'top',
										positionX: 'right',
										delay: 3000,
										type: 'success'
									});
									$rootScope.$broadcast('ReloadOrdenesActivas');
									$rootScope.blurry = false;
									close();
								}, function () {
									//console.log('ACEPTACION DIRECTA: ERROR pasando servicio a ACEPTADO (100)');
									$rootScope.blurry = false;
									close();
								});
							};
							break;
					}

					

                    modal.discard = function () {
                        service.discardService(order);
                        $rootScope.blurry = false;
                        close();
                    };

                    modal.serviceInfo = function () {
                        $state.go('flota.ordenes.editar', {
                            'id': order.orderId
                        });
                        $rootScope.blurry = false;
                        close();
                    };

                    modal.changeState = function (state) {
                        ordersService.legacyChangeAssignmentState(order.orderId, state,
                            null, null, null).then(function (data) {
                            $rootScope.$broadcast('ReloadOrdenesActivas');
                            $rootScope.blurry = false;
                            close();
                        }, function (data) {
                            $rootScope.blurry = false;
                            close();
                        });
                    };

                    modal.cancel = function (){
                        $rootScope.blurry = false;
                        close();
                    };

                },
                controllerAs: 'modal'
            });
        }

        function showErrorModal(order) {
            ModalService.showModal({
                template: showErrorServiceTemplate,
                controller: function (close) {

                    var modal = this;
                    modal.reintentar = order.assignmentState === 4;
                    modal.errorMsg = order.msgAseg || MSG_ERROR_DEFAULT;

                    modal.discard = function () {
                        service.discardService(order);
                        $rootScope.blurry = false;
                        close();
                    };

                    modal.retry = function () {

                        ordersService.changeAssignmentState(order.orderId, 0).then(function () {
                            //console.log('REINTENTAR: servicio pasado a PENDIENTE ACEPTACION (0)');
                            $rootScope.$broadcast('ReloadOrdenesActivas');
                            $rootScope.blurry = false;
                            close();
                        }, function () {
                            //console.log('REINTENTAR: ERROR pasando servicio pasado a PENDIENTE ACEPTACION (0)');
                            $rootScope.blurry = false;
                            close();
                        });

                    };

                },
                controllerAs: 'modal'
            });
        }
    }
})();